module.exports = __webpack_public_path__ + "media/images/admin/icons/layers-545d0f51e74c7433cf988b0cfa78622e.svg";